import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import { SetContextLink } from "@apollo/client/link/context";
import { API_URL, getStrapiApiKey } from "../config/index.js";

export const graphQlClient = (props = {}) => {
  const { customHeaders } = props;

  const httpLink = new HttpLink({ uri: `${API_URL}/graphql` });

  const extraHeaders = !!customHeaders ? customHeaders : {};

  const authLink = new SetContextLink(({ headers }, _) => {
    return {
      headers: {
        ...extraHeaders,
        ...headers,
        Authorization: `Bearer ${getStrapiApiKey()}`,
      },
    };
  });

  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    shouldBatch: true,
  });
};

// module.exports = { graphQlClient };
